<template>
  <v-date-picker
    color="gray"
    :model-value="modelValue"
    :min-date="minDate"
    :max-date="maxDate"
    @update:model-value="$emit('update:modelValue', $event)"
  >
    <template #default="{ inputValue, togglePopover }">
      <text-input
        name="send date"
        type="text-as-button"
        label="Date"
        icon-class="fa-calendar"
        :model-value="inputValue"
        @click="togglePopover"
      />
    </template>
  </v-date-picker>
</template>

<script>
  /** https://v2.vcalendar.io/installation.html */
  import { DatePicker as VDatePicker } from 'v-calendar';
  import moment from 'moment-timezone';

  export default {
    name: 'DatePicker',

    components: {
      VDatePicker
    },

    props: {
      maxDate: {
        type: Date,
        required: true
      },

      modelValue: {
        type: Date,
        required: true
      }
    },

    /** TODO: update/customize minDate computed value for more broad use as a component */
    computed: {
      minDate() {
        return moment().add(1, 'days').toDate();
      }
    }
  };
</script>

<style lang="sass">
  .vc-popover-content-wrapper
    z-index: 100 !important

  .vc-highlight
    background-color: var(--color-brand-primary) !important
</style>

